import React, { useEffect, useState } from "react";
import HeaderBar from "./common/HeaderBar";
import { useParams } from "react-router-dom";
import { getProductDetailById } from "../apis/GetProduct";
import { useDispatch, useSelector } from "react-redux";
import { addItem } from "../store/cartSlice";
import { useNavigate } from "react-router-dom";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import FooterBar from "./common/FooterBar";
import { getCategoryList } from "../apis/GetProduct";
import Star from "../icon/Star";
import { currency } from "./common/Common";
import Select from "react-select";
import Shipping from "../icon/Shipping";
import Shop from "../icon/Shop";

const ProductDetail = () => {
  const { id } = useParams();
  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState(null);
  const [isActive, setIsActive] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [sku, setSku] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setProductId(id);
    let product = getProductDetailById(parseInt(id));
    setProduct(product);
  }, [id]);

  const handleAddToCart = (product) => {
    dispatch(addItem(product));
    routeToPage(navigate, PagePath.CART_PAGE);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const getList = async () => {
      const list = await getCategoryList("You may also like");
      setProductList([list]);
    };
    getList();
  }, []);

  // 鼠标悬停切换图片
  const handleHover = (listIndex, itemIndex, ishover) => {
    setProductList((prev) =>
      prev.map((list, lIdx) =>
        lIdx === listIndex
          ? {
              ...list,
              list: list.list.map((item, iIdx) =>
                iIdx === itemIndex ? { ...item, ishover } : item,
              ),
            }
          : list,
      ),
    );
  };

  const updateProduct = (skuIndex, index) => {
    setProduct((prev) => {
      const newSku = prev.sku.map((s, i) => {
        if (i === skuIndex) {
          return {
            ...s,
            list: s.list.map((item, j) => ({
              ...item,
              checked: j === index,
            })),
          };
        }
        return s;
      });

      return {
        ...prev,
        sku: newSku,
      };
    });
  };

  const setSkuChecked = (value, index) => {
    setProduct({ ...product, checked: value });
    // setIsActive(index)
  };

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto mb-20 max-w-container">
        <div className="mx-auto p-10">
          <div className="mx-auto grid grid-cols-1 gap-5 lg:grid-cols-[0.6fr_0.4fr]">
            {/* left */}
            <div className="">
              {/* big image */}
              {/* <div className="aspect-[2/2] overflow-hidden">
                <img
                  src={product?.image[isActive]}
                  alt=""
                  className="h-auto w-full object-contain"
                />
              </div> */}
              {/* thumbnails */}
              <div className="grid grid-cols-2 gap-4">
                {product?.image?.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => setIsActive(index)}
                    className={`cursor-pointer overflow-hidden rounded-md transition`}
                  >
                    <img src={item} alt="" className="w-full object-cover" />
                  </div>
                ))}
              </div>
            </div>
            {/* right */}
            <div className="sticky top-20 self-start pl-10">
              {/* sticky content */}

              {/* title */}
              <div className="text-[25px] font-bold">{product?.title}</div>
              <div className="mt-4">{product?.title1}</div>
              <div className="flex py-3">
                <Star size={14} color="#000" />
                <Star size={14} color="#000" />
                <Star size={14} color="#000" />
                <Star size={14} color="#000" />
                <Star size={14} color="#000" />
                <span className="ml-2">(99+ Reviews )</span>
              </div>
              <div>
                {/* price */}
                <div className="my-4 text-[22px] font-extralight">
                  <span className="pr-1 text-[14px]">{currency}</span>
                  {product?.price?.toLocaleString()}
                </div>

                {/* sku */}
                <div className={`${product?.sku && "mt-10"} space-y-8`}>
                  {product?.sku?.map((item, index) => (
                    <div key={index}>
                      <div className="mb-4 text-[14px] font-medium">
                        {item.title}: {product?.checked}
                      </div>

                      <div className="flex flex-wrap gap-3">
                        {item.list?.map((li, liIndex) => (
                          <button
                            key={liIndex}
                            onClick={() => setSkuChecked(li, liIndex)}
                            className={`min-w-[80px] border px-5 py-3 text-[12px] transition ${
                              product?.checked === li
                                ? `border-btn bg-btn text-white`
                                : "border-gray-300 hover:border-black"
                            } `}
                          >
                            {li}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                {/* <div className="item-centers flex border-b border-black/20 py-6 text-[14px]">
                  <Shipping size={20} color="#333" className="mr-2" /> FREE
                  SHIPPING
                </div>
                <div className="item-centers flex border-b border-black/20 py-6 text-[14px]">
                  <Star size={20} color="#333" className="mr-2" />
                  100% HANDMADE
                </div>
                <div className="item-centers flex border-b border-black/20 py-6 text-[14px]">
                  <Shop size={20} color="#333" className="mr-2" />
                  MADE WITH PREMIUM LEATHER
                </div> */}

                {/* tip */}
                <div className="mt-5 text-[30px] font-bold uppercase leading-10">
                  {product?.tip}
                </div>
                <div className="mt-2 justify-center text-[14px] leading-4">
                  {product?.descript?.map((item, index) => (
                    <p key={index}>{item}</p>
                  ))}
                </div>
                {/* add to cart */}
                <button
                  className="group relative mt-4 w-full overflow-hidden border border-borderColor bg-btn px-8 py-4 text-[14px] text-white"
                  onClick={() => handleAddToCart(product)}
                >
                  <span>Add To Cart</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {productList?.map((item, listIndex) => {
          return (
            <div
              className="mx-auto my-section max-w-container p-[20px]"
              key={listIndex}
            >
              <div className="mb-20 text-center text-[30px] font-medium uppercase tracking-[3px]">
                {item?.category}
              </div>
              <div className="mx-auto grid items-start gap-5 text-center sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                {item?.list?.map((i, itemIndex) => (
                  <div
                    key={itemIndex}
                    onClick={() =>
                      routeToPage(
                        navigate,
                        `${PagePath.PRODUCTDETAIL_PAGE}/${i.id}`,
                      )
                    }
                  >
                    <div
                      className="mb-5 overflow-hidden rounded-md"
                      onMouseEnter={() =>
                        handleHover(listIndex, itemIndex, true)
                      }
                      onMouseLeave={() =>
                        handleHover(listIndex, itemIndex, false)
                      }
                    >
                      <img
                        src={
                          i.ishover ? (i.image[1] ?? i.image[0]) : i.image[0]
                        }
                        alt=""
                        className="h-full w-full object-cover"
                      />
                    </div>
                    <div className="my-2 text-[16px]">
                      {i.title} {i.title1}
                    </div>
                    <div className="price text-[14px] font-bold text-price">
                      {currency}
                      {i.price?.toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default ProductDetail;
